module.exports = __webpack_public_path__ + "img/partner11.500df2dc.png";